export const StepStatus = {
  Preparing: "preparing",
  Ready: "ready",
  Testing: "testing",
  EndClose: "endClose",
  UnLogin: "unLogin",
};
